import React from "react";

export type CallMethod = "phone" | "whatsapp";

interface Props {
  value: CallMethod;
  onChange: (method: CallMethod) => void;
  /** Patient has already approved WhatsApp calls on the selected number. */
  whatsappApproved?: boolean;
}

/**
 * Phone vs WhatsApp, shared by the two call popups.
 *
 * The approval badge sits on the WhatsApp row rather than in the hint below it
 * so it stays visible while Phone is selected - that is the thing worth knowing
 * before choosing, and the hint only renders once WhatsApp is picked.
 */
export const CallMethodSelector: React.FC<Props> = ({ value, onChange, whatsappApproved }) => (
  <div>
    <label className="block text-sm font-medium text-[#366A75] mb-2">Call Method</label>
    <div className="space-y-2">
      {([
        { value: "phone", label: "Phone" },
        { value: "whatsapp", label: "WhatsApp" },
      ] as { value: CallMethod; label: string }[]).map((opt) => (
        <label
          key={opt.value}
          className="flex items-center gap-3 cursor-pointer px-4 py-2 rounded-lg bg-[#EBF5F5] hover:bg-[#D0E7E5] transition-colors"
        >
          <input
            type="radio"
            name="call-method"
            value={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            className="accent-[#366A75]"
          />
          <span className="text-sm text-[#366A75] font-medium">{opt.label}</span>
          {opt.value === "whatsapp" && whatsappApproved && (
            <span className="ml-auto text-xs font-medium text-green-700 bg-green-100 rounded-full px-2 py-0.5 whitespace-nowrap">
              ✓ Approved
            </span>
          )}
        </label>
      ))}
    </div>
  </div>
);

export default CallMethodSelector;
